import { ContainerModule } from 'inversify';

import { Injects, IBaseDataList, ISkinDesc, ICabinetOptions, BaseCabinet, BigWin, IBigWinOptions, queryStringParams, ITranslationVersions, isInternationalBuild } from '@game-studio/arcade-base';

import { coreDataList } from '@/src/skins/core/data-list';
import { debugModel, DebugModel } from '@/src/core/models/debug';
import { gameModel, GameModel } from '@/src/core/models/game-model';
import { gameSettings, GameSettings } from '@/src/core/models/game-settings';
import { GameApplication } from '@/src/core/views/game/application';

export const containerModule = new ContainerModule((bind) => {
    bind<IBaseDataList>(Injects.CoreDataList).toConstantValue(coreDataList);
    bind<GameModel>(Injects.GameModel).toConstantValue(gameModel);
    bind<GameSettings>(Injects.GameSettings).toConstantValue(gameSettings);
    bind<DebugModel>(Injects.DebugModel).toConstantValue(debugModel);

    bind<ITranslationVersions>(Injects.TranslationVersions).toConstantValue({
        errors: 1,
        game: 1,
        shared: 1,
        chatRules: 1
    });

    bind<() => void>(Injects.SkinFactory).toFactory(() => {
        if (isInternationalBuild()) {
            const skinName = queryStringParams.currentSkin;
            bind(Injects.UserPrefsGameName).toConstantValue(skinName);
        }
        return async () => {
            const skinName = queryStringParams.currentSkin;

            try {
                const { skinDataList, skinConfig } = await import(`@/src/skins/${skinName}`);
                if (skinDataList === undefined) {
                    console.error(`skinDataList export missing in @/src/skins/${skinName}.`);
                }
                if (skinConfig === undefined) {
                    console.error(`skinConfig export missing in @/src/skins/${skinName}.`);
                }

                const skin = { dataList: skinDataList, config: skinConfig } as ISkinDesc;
                bind<ISkinDesc>(Injects.Skin).toConstantValue(skin);
            } catch (error) {
                console.error(`${error} in @/src/skins/. Folder and skin name must match exactly.`);
            }
        };
    });

    bind<() => void>(Injects.ComponentsFactory).toFactory(() => {
        return () => {
            const cabinetOptions: ICabinetOptions = {
                revealMode: {
                    canRevealAll: { value: true, buttonTextureName: '' },
                    // canStopRevealAll: false
                },
                postGameDurationMS: 1000,
                visibility: {
                    portrait: false,
                    landscape: false
                },
                minimumReactivationTimeMS: 5000
            };
            const cabinet = new BaseCabinet(cabinetOptions);
            bind<BaseCabinet>(Injects.Cabinet).toConstantValue(cabinet);

            const bigWinOptions: Partial<IBigWinOptions> = {
                // TODO: Configure your bigwin component here
                assetNames: {
                    spine: 'bigWin',
                    sounds: {
                        on: 'bigWinSfx',
                        off: ''
                    }
                }
            };
            bind<BigWin>(Injects.BigWin).toConstantValue(new BigWin(bigWinOptions));
        };
    });



    bind(Injects.GameApp).toConstantValue(new GameApplication());
});
